import React from 'react';
import Navigation from './Navigation';
import TrialStatusBanner from './TrialStatusBanner';

const AuthenticatedLayout = ({ children, user, onLogout, isCollapsed, onToggleCollapse, fullWidth = false }) => (
  <div className="flex">
    <Navigation
      user={user}
      onLogout={onLogout}
      isCollapsed={isCollapsed}
      onToggleCollapse={onToggleCollapse}
    />
    <main className={`flex-1 min-w-0 max-w-full overflow-x-hidden overflow-y-auto text-sm md:text-base px-4 sm:px-6 pt-20 pb-20 lg:pt-6 lg:pb-10 ${isCollapsed ? 'lg:ml-20' : 'lg:ml-64'}`}>
      {fullWidth ? (
        <>
          <TrialStatusBanner />
          {children}
        </>
      ) : (
        <div className="max-w-screen-2xl mx-auto w-full">
          <TrialStatusBanner />
          {children}
        </div>
      )}
    </main>
  </div>
);

export default AuthenticatedLayout;
